import { DEFAULT_REFUND_DAYS, clauseText, isClauseKey, } from './agreement-clauses.js';
import { agreementStrings } from './agreement-text.js';
import { poweredBlock } from './footer.js';
import { dateIst, rupees } from './money.js';
import { scriptRuns } from './memo-text.js';
export function agreementSections(data, estimate) {
    const lang = data.lang ?? 'en';
    const s = agreementStrings(lang);
    const day = (date) => dateIst(date, lang);
    const params = {
        noticeDays: data.noticeDays,
        refundDays: data.refundDays ?? DEFAULT_REFUND_DAYS,
        permittedUse: data.permittedUse,
    };
    const chosen = (data.clauses ?? []).filter(isClauseKey);
    const clauses = [
        s.grant(data.licensor, data.licensee, data.address, data.permittedUse),
        s.term(data.termMonths, day(data.startDate)),
        s.fee(rupees(data.rentPaise), rupees(data.depositPaise)),
        data.escalationPercent > 0 ? s.escalation(data.escalationPercent) : s.noEscalation,
        s.lockIn(data.lockInMonths, data.noticeDays),
        ...chosen.map((key) => clauseText(key, lang, params)),
    ];
    if (data.extraClauses !== null && data.extraClauses !== '')
        clauses.push(data.extraClauses);
    return {
        lang,
        title: s.title,
        disclaimer: s.disclaimer,
        clauses,
        estimateHeading: s.estimateHeading,
        estimateNote: `${[estimate.label, s.estimateNote === '' ? null : s.estimateNote]
            .filter((part) => part !== null)
            .join(' · ')} (${s.rulesVersion(estimate.rulesVersion)})`,
        estimateRows: [
            [s.stampDuty, rupees(estimate.stampDutyPaise)],
            [s.registrationFee, rupees(estimate.registrationFeePaise)],
            [s.handling, rupees(estimate.documentHandlingPaise)],
            [s.total, rupees(estimate.totalPaise)],
        ],
    };
}
/**
 * The leave and license draft as a pdfmake document definition. It is watermarked as a draft,
 * says at the top and the bottom that it is a draft and not legal advice, and every figure carries
 * the estimate label and rule version (R18).
 */
export function agreementDocDefinition(data, estimate, options) {
    const sections = agreementSections(data, estimate);
    const T = (text) => scriptRuns(text, sections.lang);
    const line = (text, extra = {}) => ({ text: T(text), ...extra });
    return {
        watermark: { text: 'DRAFT for registration', color: '#999999', opacity: 0.2, bold: true },
        content: [
            { text: T(data.agencyName), style: 'brand' },
            line(sections.title, { style: 'title' }),
            line(sections.disclaimer, { style: 'disclaimer' }),
            ...sections.clauses.map((text, index) => line(`${String(index + 1)}. ${text}`, { margin: [0, 3, 0, 3] })),
            line(sections.estimateHeading, { style: 'h2' }),
            line(sections.estimateNote, { style: 'muted' }),
            {
                table: {
                    widths: ['*', 'auto'],
                    body: sections.estimateRows.map(([label, value]) => [{ text: T(label) }, value]),
                },
            },
            line(sections.disclaimer, { style: 'disclaimer', margin: [0, 16, 0, 0] }),
            poweredBlock(options, [0, 24, 0, 0]),
        ],
        defaultStyle: { font: 'Roboto', fontSize: 10 },
        styles: {
            brand: { fontSize: 16, bold: true },
            title: { fontSize: 14, bold: true, margin: [0, 6, 0, 4] },
            h2: { fontSize: 11, bold: true, margin: [0, 12, 0, 4] },
            muted: { color: '#555555', fontSize: 9 },
            disclaimer: { bold: true, fontSize: 10, margin: [0, 0, 0, 8] },
        },
    };
}
//# sourceMappingURL=agreement.js.map